"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeTexts = exports.useTexts = void 0;
var useTexts_1 = require("./useTexts");
Object.defineProperty(exports, "useTexts", { enumerable: true, get: function () { return useTexts_1.useTexts; } });
var mergeTexts_1 = require("./mergeTexts");
Object.defineProperty(exports, "mergeTexts", { enumerable: true, get: function () { return mergeTexts_1.mergeTexts; } });
//# sourceMappingURL=index.js.map